export enum OnboardingKybStatusEnum {
  kybNotStarted = 0,
  KybStartedNotCompleted = 1,
  PendingVerification = 2,
  InReview = 3,
  ChangesRequested = 4,
  Verified = 5,
  Rejected = 6,
  Approved = 7,
  ThirdPartyVerification = 8,
  Archived = 9,
}
